import type { LucideIcon, LucideProps } from 'lucide-react';
import { cx } from '../../utils/cx';
import s from './Icon.module.css';

export type IconSize = 'sm' | 'md' | 'lg';

export type IconProps = Omit<LucideProps, 'size' | 'ref'> & {
  /** A lucide-react icon component, e.g. `Gift`. */
  icon: LucideIcon;
  size?: IconSize;
  /** Accessible name. Omit for decorative icons (the default): they're hidden from screen readers. */
  label?: string;
};

/** Every icon in the app goes through this: consistent size tokens, stroke, and a11y. */
export function Icon({ icon: Glyph, size = 'md', label, className, ...rest }: IconProps) {
  return (
    <Glyph
      className={cx(s.icon, className)}
      data-size={size}
      strokeWidth={2.25}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
      focusable="false"
      {...rest}
    />
  );
}
